import { BusinessSearchValue } from "./business-search-component.domain";
import { EntityTypeValue } from "./entity-type-component.domain";
import { AddressComponentValue } from "./google-address-component.domain";
import { PrimaryIndustrySelectionValue } from "./primary-industry-selection-component.domain";
  import { SecondaryIndustrySelectionValue } from "./secondary-industry-selection-component.domain";
import {PolicyValue} from './policy-component.domain';
import { AuthorisedSignatoryValue } from "./authorised-signatory-component.domain";
import { ContactValue, SummaryContactValue } from "./select-contact-component.domain";
import { UserSelectionValue } from "./user-selection-component.domain";
import { ApplicationApplicant } from "../../domain/types.domain";
import { SalesforceContactSameAccountSelectionValue } from "./salesforce-contact-same-account-selection-component.domain";
import { LoanPurposeValue } from "./loan-purpose-selection-component.domain";
import { SubdivisionIndustrySelectionValue } from "./subdivision-industry-selection-component.domain";

export interface InsurancePremiumSummary {
  monthlyRepayment: string;
  applicationId: string;
  organisation: BusinessSearchValue;
  organisationType: EntityTypeValue;
  addtionalBrokerCorrespondent: UserSelectionValue;
  abn: string;
  acn?: string;
  annualRevenue: number;
  primaryIndustry: PrimaryIndustrySelectionValue,
  industrySector: SecondaryIndustrySelectionValue,
  primaryBusinessAddress: AddressComponentValue,
  registeredBusinessAddress?: AddressComponentValue,
  subdivisionIndustrySector: SubdivisionIndustrySelectionValue,
  policies: PolicyValue;
  loanPurpose: LoanPurposeValue;
  applicants: Exclude<ApplicationApplicant, null>;
  authorisedSignatories: AuthorisedSignatoryValue;
  primaryContact: ContactValue;

  contacts?: SummaryContactValue[];
  applicationNotes: string;
  brokerContact:SalesforceContactSameAccountSelectionValue
}
